// extracted by mini-css-extract-plugin
export default {"mainContainer":"layout_mainContainer__tHvoh","heightReduce":"layout_heightReduce__h+HkA","topRadius":"layout_topRadius__DP5OX"};